import React from "react";

export default function Loader() {
  return (
    <div
      className="view viewport-height position-fixed three-b opacity-75 w-100 z-max"
      style={{ left: 0, top: 0, bottom: 0, right: 0 }}
    >
      <div className="progress md-progress primary-color z-3 mb-0">
        <div className="indeterminate"></div>
      </div>

      <div className="mask d-flex justify-content-center align-items-center">
        <div className="preloader-wrapper active crazy">
          <div className="spinner-layer spinner-red-only spinner-primary">
            <div className="circle-clipper left">
              <div className="circle"></div>
            </div>
            <div className="gap-patch">
              <div className="circle"></div>
            </div>
            <div className="circle-clipper right">
              <div className="circle"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}



// WEBPACK FOOTER //
// ./resources/js/components/Loader/index.js